<div class="d-flex flex-column align-items-center justify-content-center w-100 gap-1 h-100">
    <div class="image">
        <img class="image-logo" style="height: 80px;" [src]="'/assets/system/logo_sidebar_resized.png'">
    </div>
    <div class="mt-4" style="text-align: center;">
        <p>Su {{esCuentaPrueba ? 'periodo de prueba' : 'suscripción'}} ha vencido.</p>
    </div>
    <div style="text-align: center;">
        <p *ngIf="esAdmin">Para continuar utilizando <b>Lubrikuv</b>, por favor {{infoPlan.nombre ? 'reactive' : 'active'}} su suscripción.</p>
        <p *ngIf="!esAdmin">Para continuar utilizando <b>Lubrikuv</b>, por favor informe a su administración para que
            active la suscripción.</p>
    </div>
    <div *ngIf="!esCuentaPrueba && esAdmin" class="info-suscripcion">
        <div *ngIf="!infoPlan.nombre">
            <div class="shimmer" style="font-size: 18px;">
                <label>&nbsp;</label>
            </div>
            <div class="currency shimmer mt-3">
                <label>&nbsp;</label>
            </div>
        </div>
        <!--div *ngIf="infoPlan.nombre">
            <p>Plan Actual</p>
            <div>
                <i class="fa-solid fa-crown" style="color: #efbf04; margin-right: 8px; font-size: 18px;"></i>
                <b style="font-size: 18px;">
                    {{infoPlan.nombre ? 'Plan ' + infoPlan.nombre : ''}}
                </b>
            </div>
            <label class="currency mt-3">{{infoPlan.monto ? infoPlan.monto : ''}}</label>
        </div-->

    </div>
    <div class="mt-3" *ngIf="esAdmin">
        <button class="btn btn-primary submit-button" (click)="realizarPagoPremium()">Activar Suscripción</button>
    </div>
    <div class="d-flex flex-row align-items-center justify-content-center mt-3" *ngIf="esAdmin">
        <button class="btn btn-outline-secondary help-button" (click)="contactoVentas()">Contactar con Ventas
        </button>
    </div>
    <div class="d-flex flex-row align-items-center justify-content-center mt-3">
        <button class="btn btn-outline-secondary help-button" (click)="contactoSoporte()">Contactar con Soporte
        </button>
    </div>
</div>